<div id="GeoPortaleComponent" class="card esri-widget animated zoomIn" #geoPortaleComponentRef>
  <!--- the card header -->
  <div class="card-header">
    <div class="row">
      <div class="col-md-9" translate>
        WIDGET.GEO_PORTALE.PANEL_HEADING
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>
  <!-- the card body -->
  <div class="card-body">
    <table class="table table-borderless table-hover">
      <tr *ngFor="let geoPortal of geoPortale.geoPortale; let i = index;">
        <td class="story">{{ geoPortal.label }}</td>
        <td><a href="//{{ geoPortal.url }}" target="_blank">{{ geoPortal.url }}</a></td>
      </tr>
    </table>
  </div>
</div>
